import styled from "styled-components";

export const RodapeCancelamento = styled.div`
    margin-bottom: 16px;
`;

export const RodapeContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const AvatarContainer = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 6px;
    background-color: ${({ theme }) => theme.colors.interfacePure0 || '#FFFFFF'};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.1);
`;

export const InfoContainer = styled.div`
    flex: 1;
    min-width: 0;
`;

export const NomeContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
`;

export const NomeProfissional = styled.strong`
    color: ${(props: any) => props.theme.colors.interfaceText};
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
`;

export const CodigoProfissional = styled.span`
    color: ${(props: any) => props.theme.colors.c64748b};
    font-size: 11px;
    font-weight: 400;
    line-height: 16px;
`;

